"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.HatCustomErrorMessages = exports.HatCustomErrorCauses = exports.HatCustomError = void 0;
var HatCustomError = /** @class */ (function (_super) {
    __extends(HatCustomError, _super);
    function HatCustomError(cause, message, status) {
        if (cause === void 0) { cause = 'GENERIC'; }
        if (message === void 0) { message = 'GENERIC_MESSAGE'; }
        if (status === void 0) { status = 500; }
        var params = [];
        for (var _i = 3; _i < arguments.length; _i++) {
            params[_i - 3] = arguments[_i];
        }
        var _this = _super.apply(this, params) || this;
        if (Error.captureStackTrace) {
            Error.captureStackTrace(_this, HatCustomError);
        }
        _this.cause = cause;
        _this.status = status;
        _this.message = message;
        return _this;
    }
    return HatCustomError;
}(Error));
exports.HatCustomError = HatCustomError;
var HatCustomErrorCauses;
(function (HatCustomErrorCauses) {
    HatCustomErrorCauses["tokenValidation"] = "HAT_TOKEN_VALIDATION";
    HatCustomErrorCauses["hatClientValidation"] = "HAT_CLIENT_VALIDATION";
    HatCustomErrorCauses["hatApiException"] = "HAT_API_EXCEPTION";
    HatCustomErrorCauses["hatFileApi"] = "HAT_FILE_API_EXCEPTION";
})(HatCustomErrorCauses = exports.HatCustomErrorCauses || (exports.HatCustomErrorCauses = {}));
var HatCustomErrorMessages;
(function (HatCustomErrorMessages) {
    HatCustomErrorMessages["tokenIsNotValidOrExpired"] = "HAT_TOKEN_IS_NOT_VALID_OR_EXPIRED";
    HatCustomErrorMessages["tokenIsUndefined"] = "HAT_TOKEN_IS_UNDEFINED";
    HatCustomErrorMessages["tokenFailedToDecode"] = "HAT_TOKEN_FAILED_TO_DECODE";
    HatCustomErrorMessages["notAuthenticated"] = "NOT_AUTHENTICATED";
    HatCustomErrorMessages["httpResponseFailed"] = "HTTP_RESPONSE_FAILED";
    HatCustomErrorMessages["fileIsUndefined"] = "FILE_IS_UNDEFINED";
    HatCustomErrorMessages["fileFailedToFetchMetadata"] = "FAILED_TO_FETCH_METADATA";
    HatCustomErrorMessages["fileFailedToUpload"] = "FILE_FAILED_TO_UPLOAD";
    HatCustomErrorMessages["hatDomainIsUndefined"] = "HAT_DOMAIN_IS_UNDEFINED";
    HatCustomErrorMessages["applicationNotSupported"] = "APPLICATION_NOT_SUPPORTED";
    HatCustomErrorMessages["recordIdsMissing"] = "RECORD_IDS_MISSING";
})(HatCustomErrorMessages = exports.HatCustomErrorMessages || (exports.HatCustomErrorMessages = {}));
